<mat-card appearance="raised">
  <mat-card-header class="campusSupervisorAssignment--right">
    <mat-card-title>Assigned Campus Supervisors</mat-card-title>
    <div class="campusSupervisorAssignment--right">
      <button type="button" class="campusSupervisorAssignment--button" color="primary" mat-button
        mat-raised-button (click)="addNewCampusSupervisorAssignment()"
        [disabled]="expandedCampusSupervisorAssignmentRow || loadingCampusSupervisorAssignments || !hasValidEmployment">
        <mat-icon class="campusSupervisorAssignment--button__icon">assignment_ind</mat-icon>
        Assign Campus Supervisor
      </button>
    </div>
  </mat-card-header>
  <mat-card-content>
    <div class="no-assigned-campusSupervisors-message">
      @if (campusSupervisorAssignments?.length === 0) {
        <span>A campus supervisor has not been assigned</span>
      }
    </div>
    @if (campusSupervisorAssignments?.length > 0) {
      <table mat-table [dataSource]="campusSupervisorAssignmentSource" multiTemplateDataRows
        >
        <ng-container matColumnDef="Campus">
          <th mat-header-cell *matHeaderCellDef>Campus</th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment">
            {{campusSupervisorAssignment.CampusName}}
          </td>
        </ng-container>
        <ng-container matColumnDef="Name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment"
            [ngClass]="{'hyperlink-cell':campusSupervisorAssignment.Index != 0, 'normal-cell':campusSupervisorAssignment.Index === 0 || editingContact}">
            @if (campusSupervisorAssignment.Index != 0 && !editingContact) {
              <a (click)="editAssignedCampusSupervisor(campusSupervisorAssignment)"
                matTooltip="Edit Campus Supervisor">{{campusSupervisorAssignment.FirstName}}
              {{campusSupervisorAssignment.LastName}}</a>
            }
            @if (campusSupervisorAssignment.Index == 0 || editingContact) {
              {{campusSupervisorAssignment.FirstName}} {{campusSupervisorAssignment.LastName}}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="Email">
          <th mat-header-cell *matHeaderCellDef class="campusSupervisor-email-cell">Email</th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment">
            {{campusSupervisorAssignment.EmailAddress}}
          </td>
        </ng-container>
        <ng-container matColumnDef="StartDate">
          <th mat-header-cell *matHeaderCellDef>Start Date</th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment">
            {{campusSupervisorAssignment.AssignedOn | date: 'MM/dd/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="EndDate">
          <th mat-header-cell *matHeaderCellDef>End Date</th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment">
            {{campusSupervisorAssignment.EndDate | date: 'MM/dd/yyyy'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="EndAssignment">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let campusSupervisorAssignment">
            @if (campusSupervisorAssignment.Index != 0 && !campusSupervisorAssignment.EndDate) {
              <button
                type="button" class="campusSupervisorAssignment--button" mat-button mat-raised-button
                (click)="endCampusSupervisorAssignment(campusSupervisorAssignment)">
                <mat-icon color="primary"
                class="campusSupervisorAssignment--end__button__icon">person_remove</mat-icon>
                End Assignment
              </button>
            }
          </td>
        </ng-container>
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="campusSupervisorAssignmentEditor">
          <td class="campusSupervisorAssignmentFormContainer" mat-cell
            *matCellDef="let campusSupervisorAssignment;" [attr.colspan]="campusSupervisorsListColumns.length">
            <div class="campus-supervisor-assignment-editor-container"
              [@expandAnimation]="shouldShowRow(campusSupervisorAssignment.Index) && expandedCampusSupervisorAssignmentRow ? 'expanded' : 'collapsed'">
              @if (!campusSupervisorListLoaded && !!selectedCampus && !editingContact) {
                <div>
                  <h4>Loading campus supervisors...</h4>
                  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
              }
              <form [formGroup]="campusSupervisorAssignmentEditorForm">
                @if (!editingContact) {
                  <div class="campusSupervisorAssignmentEditorFormFields">
                    <div class="formFields">
                      <div class="campusSupervisorListContainer">
                        <h4 class="campusSupervisorListContainer--label" for="campusSupervisorList">
                        Campus Supervisors</h4>
                        @if (!!selectedCampus) {
                          <div class="campusSupervisorListContainer--selectedCampusName"
                          >for {{selectedCampus.name}}</div>
                        }
                        @if (!selectedCampus) {
                          <div>(no campus selected)</div>
                        }
                        @if (campusSupervisorListLoaded && campusSupervisorList && campusSupervisorList.length > 0) {
                          <mat-selection-list [multiple]="false"
                            (selectionChange)="onCampusSupervisorSelectionChanged($event)"
                            class="campusSupervisorList" formControlName="campusSupervisor"
                            name="campusSupervisorList" id="campusSupervisorList"
                            hideSingleSelectionIndicator="true">
                            @for (campusSupervisor of campusSupervisorList; track campusSupervisor; let last = $last; let i = $index) {
                              <mat-list-option class="campusSupervisorListItem"
                                [value]="campusSupervisor.id">
                                <div matListItemTitle>
                                  <span
                                  class="campusSupervisorListItem--campusSupervisorName">{{campusSupervisor.displayName}}</span>
                                </div>
                                <div matListItemLine class="list-row">
                                  <span matListItemLine
                                    class="campusSupervisorListItem--campusSupervisorEmail">
                                    <mat-icon matListItemIcon
                                    class="campusSupervisorListItem--campusSupervisorEmail__icon">mail</mat-icon>
                                    @if (!!campusSupervisor.emailAddress) {
                                      {{campusSupervisor.emailAddress}}
                                    }
                                    @if (!campusSupervisor.emailAddress) {
                                      <span class="missingEmailAddres">(no email address)</span>
                                    }
                                  </span>
                                  <mat-icon matListItemIcon class="edit-icon"
                                    (click)="editCampusSupervisor(campusSupervisor)"
                                  color="primary" matTooltip="edit">edit</mat-icon>
                                </div>
                              </mat-list-option>
                            }
                          </mat-selection-list>
                        }
                        @if ((!campusSupervisorList || campusSupervisorList.length == 0) && campusSupervisorListLoaded) {
                          <div class="noCampusSupervisors"
                            >
                            <p class="noCampusSupervisors--message">There are no supervisor records for this campus.</p>
                          </div>
                        }
                        <div class="newCampusSupervisorSection">
                          <button class="newCampusSupervisorSection--button" mat-button
                            mat-raised-button color="primary"
                            (click)="addNewCampusSupervisor()">
                            Add New Campus Supervisor
                          </button>
                        </div>
                      </div>
                    </div>
                    @if (campusSupervisorListLoaded && campusSupervisorList) {
                      <div class="formFields--rightSide"
                        >
                        <div class="selectedCampusSupervisorFields">
                          <h2 class="formFields--contact-name">
                          {{this.selectedCampusSupervisor.displayName}}</h2>
                          <div class="formFields--rightSide--field">
                            <label>Email: </label>
                            <span><a href="mailto:{{this.selectedCampusSupervisor.emailAddress}}"
                            target="_blank">{{this.selectedCampusSupervisor.emailAddress}}</a></span>
                          </div>
                        </div>
                        <ng-template #notSelectedSupervisor>
                          <div class="selectedCampusSupervisorFields">
                            <p>Select a campus supervisor from the list.</p>
                          </div>
                        </ng-template>
                        <div>
                          <mat-form-field class="startDateField">
                            <mat-label>Start Date</mat-label>
                            <input matInput [max]="today"
                              [matDatepicker]="assignmentStartDatePicker" placeholder="Start Date"
                              formControlName="assignmentStartDate"
                              (dateChange)="onStartDateSelected($event)">
                              <mat-datepicker-toggle matSuffix
                              [for]="assignmentStartDatePicker"></mat-datepicker-toggle>
                              <mat-datepicker #assignmentStartDatePicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                          <div class="saveAndCancelButtons">
                            <button mat-button mat-raised-button color="primary"
                              (click)="saveCampusSupervisorAssignment()" type="button"
                              [disabled]="campusSupervisorAssignmentEditorForm.controls.campusSupervisor.errors || campusSupervisorAssignmentEditorForm.controls.assignmentStartDate.errors || this.saving">
                              Assign
                            </button>
                            <button mat-button mat-raised-button color="accent"
                              (click)="cancelCampusSupervisorAssignment()" type="button">
                              Cancel
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  }
                  @if (editingContact) {
                    <div class="formFields--contactEditorContainer">
                      <app-campus-contact-editor [campusContactEditor]="campusContact"
                        (saveNewContact)="saveNewContact($event)"
                        (updateContact)="updateContact($event)"
                        (cancelEvent)="cancelContactEditor(campusSupervisorAssignment.Index)">
                      </app-campus-contact-editor>
                    </div>
                  }
                </form>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="campusSupervisorsListColumns"></tr>
          <tr mat-row *matRowDef="let mentor; columns: campusSupervisorsListColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: ['campusSupervisorAssignmentEditor']"
          class="campus-supervisor-assignment-row"></tr>
        </table>
      }
    </mat-card-content>
    @if (loadingCampusSupervisorAssignments || saving) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </mat-card>
